import { Icon } from '@amili-v3/amili-v3-design';
import { AuthHeading, AuthLogoRow } from './styles';

interface AuthCardHeaderProps {
  /**
   * Page name, shown as a small tracked label under the logo. Typed as
   * ReactNode because t() is configured to allow a null return.
   */
  heading?: React.ReactNode;
}

/**
 * Shared card header for the unauthenticated pages: the logo and the page
 * name. Passed as each modal's `title` so every auth page opens the same way.
 */
const AuthCardHeader = ({ heading }: AuthCardHeaderProps) => (
  <>
    <AuthLogoRow>
      <Icon name="logoLilac" width={107} height={36} />
    </AuthLogoRow>
    {!!heading && <AuthHeading>{heading}</AuthHeading>}
  </>
);

export default AuthCardHeader;
